import { useSelector } from 'react-redux';
import { Router } from 'react-router';
import useRouterStateSync from '../hooks/useRouterStateSync';
import { getRouter } from '../selectors/router';

// react-router only ships routers that own their location (BrowserRouter and
// friends). This one renders the location the store holds, and
// useRouterStateSync feeds that store from the history.
//
// Going through the store is what keeps the route and the ~25 router selectors
// in step: one navigation is one store update, so the matched route and what
// the selectors answer can never disagree for a render. Letting react-router
// keep its own location and mirroring it into the store afterwards splits that
// in two, in two different update lanes, and an effect that navigates on what
// it reads from the store then spins between them -- the search page sending a
// single result straight to its dataflow does exactly that.
//
// Covered by components/tests/history-router.test.js, and end to end by
// tests/back-browser*.e2e.js, tests/default-time-filters.e2e.js and
// tests/search/homeToViz.e2e.js.
const HistoryRouter = ({ history, basename, children }) => {
  useRouterStateSync(history);
  const { location, action } = useSelector(getRouter);

  return (
    <Router basename={basename} location={location} navigationType={action} navigator={history}>
      {children}
    </Router>
  );
};

export default HistoryRouter;
